import React, { ReactNode } from 'react'

import { Color } from '../../enums/color'
import { Text, TextProps } from '../Text'
import * as Styled from './styles'
import { DividerDirection } from './types/dividerDirection'
import { DividerTextOrientation } from './types/dividerTextOrientation'

export interface DividerProps extends Omit<TextProps, 'children'> {
  children?: ReactNode
  className?: string
  dashed?: boolean
  direction?: DividerDirection
  dividerColor?: Color
  orientation?: DividerTextOrientation
}

export const Divider = ({
  className,
  dashed = false,
  direction = 'horizontal',
  orientation = 'center',
  dividerColor = Color.Grey150,
  children,
  ...rest
}: DividerProps) => {
  return (
    <Styled.DividerWrapper
      className={className}
      dashed={dashed}
      direction={direction}
      dividerColor={dividerColor}
      hasChildren={!!children}
      orientation={orientation}
    >
      {children && (
        <Styled.TextContainer>
          <Text colorVariant="secondary" {...rest}>
            {children}
          </Text>
        </Styled.TextContainer>
      )}
    </Styled.DividerWrapper>
  )
}
